// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  margin: 0 auto;
  width: 95%;
}
.dashboard-container__leads {
  margin-top: 30px;
}
.dashboard-container__leads--header__title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.dashboard-container__leads--header__title p {
  font-weight: bold;
  font-size: 1.5rem;
  margin: 5px;
}
.dashboard-container__leads--content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 200px));
  grid-gap: 30px;
  padding: 15px;
}
@media (max-width: 1400px) {
  .dashboard-container__leads--content {
    grid-template-columns: 250px 250px 250px 250px;
    grid-gap: 10px;
  }
}
@media (max-width: 768px) {
  .dashboard-container__leads--content {
    grid-template-columns: 0.5fr 0.5fr;
    grid-gap: 10px;
  }
}
@media (max-width: 576px) {
  .dashboard-container__leads--content {
    grid-template-columns: 1fr;
    grid-gap: 10px;
  }
}
.dashboard-container__leads--content__item {
  background-color: white;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;
  cursor: pointer;
  padding: 25px;
  display: grid;
  place-items: center;
}
.dashboard-container__leads--content__item:hover {
  transform: scale(1.1);
}
.dashboard-container__leads--content__item--text p:nth-child(1) {
  margin-top: 10px;
  font-weight: bold;
  font-size: 1.5rem;
}
.dashboard-container__leads--content__item--text p:nth-child(2) {
  font-weight: 600;
}
.dashboard-container__leads--content__item--text p {
  margin: 5px 0;
}
.dashboard-container__leadsContactPerson {
  margin-top: 15px;
}
.dashboard-container__leadsContactPerson--header__title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.dashboard-container__leadsContactPerson--header__title p {
  font-weight: bold;
  margin: 0;
  font-size: 1rem;
}
.dashboard-container__leadsContactPerson--contentPerson {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 239px));
  grid-gap: 8px;
  padding: 8px;
}
@media (max-width: 768px) {
  .dashboard-container__leadsContactPerson--contentPerson {
    grid-template-columns: 0.5fr 0.5fr;
    grid-gap: 10px;
  }
}
.dashboard-container__leadsContactPerson--contentPerson__item {
  opacity: 0;
  transition: opacity 1s ease-in-out;
  background-color: white;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;
  cursor: pointer;
  padding: 10px;
  display: grid;
  place-items: center;
  line-height: 30px;
  font-size: 14px !important;
}
.dashboard-container__leadsContactPerson--contentPerson__item * {
  margin: 0;
}
.dashboard-container__leadsContactPerson--contentPerson__item:hover {
  transform: scale(1.1);
}
.dashboard-container__leadsContactPerson--contentPerson__item--title {
  font-weight: bold;
}
.dashboard-container__leadsContactPerson--contentPerson__item.active {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/containers/Dashboard/styles.scss","webpack://./src/utils/styles/global.scss"],"names":[],"mappings":"AAEA;EACI,cAAA;EACA,UAAA;AADJ;AAEI;EACI,gBAAA;AAAR;AAGY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AADhB;AAGgB;EACI,iBAAA;EACA,iBAAA;EACA,WAAA;AADpB;AAMQ;EACI,aAAA;EACA,6DAAA;EACA,cAAA;EACA,aAAA;AAJZ;ACIQ;EDJA;IAOQ,8CAAA;IACA,cAAA;EAHd;AACF;ACpBQ;EDcA;IAYQ,kCAAA;IACA,cAAA;EAFd;AACF;AChCQ;EDoBA;IAiBQ,0BAAA;IACA,cAAA;EADd;AACF;AAGY;EACI,uBAAA;EACA,mBAAA;EACA,mDAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;AADhB;AAGgB;EACI,qBAAA;AADpB;AAKoB;EACI,gBAAA;EACA,iBAAA;EACA,iBAAA;AAHxB;AAKoB;EACI,gBAAA;AAHxB;AAKoB;EACI,aAAA;AAHxB;AAUQ;EACI,gBAAA;AARZ;AAWgB;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AATpB;AAWoB;EACI,iBAAA;EACA,SAAA;EACA,eAAA;AATxB;AAeY;EACI,aAAA;EACA,6DAAA;EACA,aAAA;EACA,YAAA;AAbhB;AC1EQ;EDmFI;IAYQ,kCAAA;IACA,cAAA;EAjBlB;AACF;AAmBgB;EACI,UAAA;EACA,kCAAA;EACA,uBAAA;EACA,kBAAA;EACA,mDAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;AAjBpB;AAmBoB;EACI,SAAA;AAjBxB;AAoBoB;EACI,qBAAA;AAlBxB;AAqBoB;EACI,iBAAA;AAnBxB;AAsCoB;EACI,UAAA;AApCxB","sourcesContent":["@import '../../utils/styles/global.scss';\n\n.dashboard-container{\n    margin: 0 auto;\n    width: 95%;\n    &__leads{\n        margin-top: 30px;\n\n        &--header{\n            &__title{\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n\n                p{\n                    font-weight: bold;\n                    font-size: 1.5rem;\n                    margin: 5px;\n                }\n            }\n        }\n\n        &--content{\n            display: grid;\n            grid-template-columns: repeat(auto-fit, minmax(100px, 200px));\n            grid-gap: 30px;\n            padding: 15px;\n\n            @include breakpoint(xxl) {\n                grid-template-columns: 250px 250px 250px 250px;\n                grid-gap: 10px;\n            }\n\n            @include breakpoint(md) {\n                grid-template-columns: 0.5fr 0.5fr;\n                grid-gap: 10px;\n            }\n\n            @include breakpoint(sm) {\n                grid-template-columns: 1fr;\n                grid-gap: 10px;\n            }\n\n            &__item{\n                background-color: white;\n                border-radius: 10px;\n                box-shadow: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;\n                cursor: pointer;\n                padding: 25px;\n                display: grid;\n                place-items: center;\n                \n                &:hover{\n                    transform: scale(1.1);\n                }\n\n                &--text{\n                    p:nth-child(1){\n                        margin-top: 10px;\n                        font-weight: bold;\n                        font-size: 1.5rem;\n                    }\n                    p:nth-child(2){\n                        font-weight: 600;\n                    }\n                    p{\n                        margin: 5px 0;\n                    }\n                }\n            }\n        }\n    }\n\n        &__leadsContactPerson {\n            margin-top: 15px;\n    \n            &--header {\n                &__title {\n                    display: flex;\n                    justify-content: space-between;\n                    align-items: center;\n    \n                    p {\n                        font-weight: bold;\n                        margin: 0;\n                        font-size: 1rem;\n                        // margin: 5px;\n                    }\n                }\n            }\n    \n            &--contentPerson {\n                display: grid;\n                grid-template-columns: repeat(auto-fit, minmax(150px, 239px));\n                grid-gap: 8px;\n                padding: 8px;\n    \n                // @include breakpoint(xxl) {\n                //     grid-template-columns: 250px 250px 250px 250px;\n                //     grid-gap: 10px;\n                // }\n    \n                @include breakpoint(md) {\n                    grid-template-columns: 0.5fr 0.5fr;\n                    grid-gap: 10px;\n                }\n    \n                &__item {\n                    opacity: 0;\n                    transition: opacity 1s ease-in-out;\n                    background-color: white;\n                    border-radius: 5px;\n                    box-shadow: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;\n                    cursor: pointer;\n                    padding: 10px;\n                    display: grid;\n                    place-items: center;\n                    line-height: 30px;\n                    font-size: 14px !important;\n    \n                    * {\n                        margin: 0;\n                    }\n    \n                    &:hover {\n                        transform: scale(1.1);\n                    }\n\n                    &--title{\n                        font-weight: bold;\n                    }\n    \n                    // &--text {\n                    //     p:nth-child(1) {\n                    //         margin-top: 10px;\n                    //         font-weight: bold;\n                    //         font-size: 1.5rem;\n                    //     }\n    \n                    //     p:nth-child(2) {\n                    //         font-weight: 600;\n                    //     }\n    \n                    //     p {\n                    //         margin: 5px 0;\n                    //     }\n                    // }\n    \n                    &.active {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n}","@mixin breakpoint($point) {\n    @if $point == sm {\n        @media (max-width: 576px) {\n            @content;\n        }\n    }\n\n    @else if $point == md {\n        @media (max-width: 768px) {\n            @content;\n        }\n    }\n\n    @else if $point == lg {\n        @media (max-width: 992px) {\n            @content;\n        }\n    }\n\n    @else if $point == xl {\n        @media (max-width: 1200px) {\n            @content;\n        }\n    }\n\n    @else if $point == xxl {\n        @media (max-width: 1400px) {\n            @content;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
